<script>
  import { Toaster, toast } from 'svelte-sonner';
  import { page, Link } from '@inertiajs/svelte'
  import Logo from '@assets/images/altruist-vertical-logo.svg'
  import Button from '@components/buttons/button.svelte'
  import { ArrowLeft } from 'lucide-svelte'

  let { children } = $props();

  $effect(() => {
    if ($page.props.flash.notice) { toast.success($page.props.flash.notice) }
    if ($page.props.flash.alert) { toast.error($page.props.flash.alert) }
  })
</script>

<div class="min-h-screen bg-gray-50">
  <header class="flex justify-center pt-10 pb-8">
    <Link href="/">
      <img src={Logo} alt="Altruist Wellbeing" class="w-28" />
    </Link>
  </header>
  <div class="w-full max-w-3xl mx-auto px-6 pb-12 relative">
    <Button variant="link" onclick={() => history.back()} text="Back" BeforeIcon={ArrowLeft} class="text-gray-400 hover:text-gray-600 mb-6 lg:absolute lg:-left-36 lg:top-1 lg:mb-0" />
    <main>
      {@render children?.()}
    </main>
  </div>
</div>

<Toaster position="top-right" />
